const types = {
  ADD_TEST_FAILURE: 'ADD_TEST_FAILURE',
  ADD_TEST_SUCCESS : 'ADD_TEST_SUCCESS',
  REMPLACE_TEST_SUCCESS: 'REMPLACE_TEST_SUCCESS',
  REMPLACE_TEST_FAILURE: 'REMPLACE_TEST_FAILURE',
}
export default types;
